import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CONTACT_DATA, CTA_LINKS } from '../../../Data/data.service';

interface ContactOption {
  icon: string;
  title: string;
  description: string;
  action: () => void;
}

@Component({
  selector: 'app-help-contact',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './help-contact.html',
  styleUrl: './help-contact.css',
})
export class HelpContactComponent {
  readonly contactData = CONTACT_DATA;
  readonly ctaLinks = CTA_LINKS;

  readonly contactOptions: ContactOption[] = [
    {
      icon: 'fas fa-calendar-check',
      title: 'Book a meeting',
      description: 'Talk to our team about your business needs.',
      action: () => window.open(this.ctaLinks.meeting.url, this.ctaLinks.meeting.target),
    },
    {
      icon: 'fas fa-envelope-open-text',
      title: 'Email us',
      description: 'Send us your question and we will get back to you.',
      action: () => (window.location.href = `mailto:${this.contactData.email}`),
    },
    {
      icon: 'fab fa-whatsapp',
      title: 'Chat on WhatsApp',
      description: 'Message our support team directly.',
      action: () => window.open(this.whatsappUrl, '_blank'),
    },
    {
      icon: 'fas fa-map-marker-alt',
      title: 'Visit us',
      description: 'Come by our office in Islamabad.',
      action: () => window.open(this.contactData.googleMapsUrl, '_blank'),
    },
  ];

  get whatsappUrl(): string {
    const link = this.contactData.socialLinks.find((social: any) => social.name === 'whatsapp');
    return link?.url ?? `https://wa.me/${this.contactData.phone.replace(/\D/g, '')}`;
  }
}
